var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1877f2;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Facebook-2",
    "data-name": "Facebook",
    className: "cls-2",
    d: "M1223.69,116.65h18l3.43-22.45h-21.41V79.64c0-6.14,3-12.13,12.58-12.13H1246V48.4a117.7,117.7,0,0,0-17.28-1.52c-17.63,0-29.15,10.75-29.15,30.22V94.2H1180v22.45h19.59v54.26h24.12Z",
    transform: "translate(-1108)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.fcdfd4825a3b2d0e33b503e168cc5854.svg";
export { ForwardRef as ReactComponent };